module.exports = __webpack_public_path__ + "assets/img/logo.efd5ba59.png";